import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../auth/api";
import { alertSuccess, alertError } from "../../components/Alert";

// Fetch Pincode List Data (with stateID)
export const fetchPincodeList = createAsyncThunk(
  "pincode/fetchPincodeList",
  async (stateID, { rejectWithValue }) => {
    try {
      let response;
      // console.log(stateID);

      if (!stateID || stateID === "undefined") {
        response = await api.get(`/location/panel/PincodeList`);
      } else {
        response = await api.get(`/location/panel/PincodeList?stateID=${stateID}`);
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Add Pincode to the List
export const addPincodeList = createAsyncThunk(
  "pincode/addPincodeList",
  async (newPincodeData, { rejectWithValue }) => {
    try {
      const response = await api.post("/location/panel/PincodeList", newPincodeData);
      alertSuccess(response.data.success);
      return newPincodeData;
    } catch (error) {
      console.log(error.message);
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Update Pincode List Data
export const updatePincodeList = createAsyncThunk(
  "pincode/updatePincodeList",
  async (pincodeData, { rejectWithValue }) => {
    try {
      const response = await api.patch("/location/panel/PincodeList", pincodeData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Pincode List Slice
const pincodeSlice = createSlice({
  name: "pincode",
  initialState: {
    pincodeList: [],
    status: "idle",
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Pincode List
      .addCase(fetchPincodeList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchPincodeList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.pincodeList = action.payload;
      })
      .addCase(fetchPincodeList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Add Pincode
      .addCase(addPincodeList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addPincodeList.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(addPincodeList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Update Pincode List
      .addCase(updatePincodeList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updatePincodeList.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(updatePincodeList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearError } = pincodeSlice.actions;

export default pincodeSlice.reducer;
